import styled from 'styled-components';

import { Color, Gradient } from '../../constants/Colors';
import { MediaQuery } from '../../constants/Styles';
import { Typography } from '../../constants/Typographies';

export const Wrapper = styled.div`
  padding: 0px 300px;
  display: flex;
  justify-content: center;

  ${MediaQuery.XL_AND_DOWN} {
    padding: 0px 150px;
  }

  ${MediaQuery.L_AND_DOWN} {
    padding: 0px 45px;
  }

  ${MediaQuery.M_AND_DOWN} {
    padding: 0px;
  }
`;

export const Banner = styled.div`
  border-radius: 100px;
  display: flex;
  max-width: 700px;
  max-height: 75px;
  min-width: ${({ is404 }) => is404 && '400px'};
  width: 100%;
  padding: ${({ is404 }) => (is404 ? '20px 20px 20px 20px' : '0px 35px')};
  align-items: center;
  margin: ${({ is404 }) => (is404 ? 'none' : '25px 0px 50px 0px')};
  flex-direction: row;
  overflow: hidden;
  box-shadow: 0px 15px 30px rgba(20, 106, 255, 0.1);
  border: 5px solid ${Color.WHITE};
  background: linear-gradient(180deg, #ffd392 0%, #ffb522 100%);

  ${MediaQuery.M_AND_DOWN} {
    ${({ is404 }) =>
      !is404 &&
      `
    max-width: none;
    margin: 0px;
    border: none;
    border-radius: 0;
    padding: 20px 20px;
    
    `}

    min-width: ${({ is404 }) => is404 && 'initial'};
  }

  ${MediaQuery.S_AND_DOWN} {
    ${({ is404 }) =>
      !is404 &&
      `
    flex-direction: column;
    margin: 0px 0px 50px 0px;
    padding: 20px 20px 30px 20px;
    `}
  }
`;

export const IllustrationWrapper = styled.div`
  ${MediaQuery.M_AND_DOWN} {
    display: none;
  }

  img {
    height: 107px;
  }
`;

export const BannerLabel = styled.span`
  ${Typography.L};
  margin: 0 15px 0 10px;
  white-space: nowrap;

  ${MediaQuery.M_AND_DOWN} {
    ${({ is404 }) =>
      !is404 &&
      `
    white-space: initial;
    margin: 0px;
    flex-shrink: 1.5;
    width: 100%;
    `}
  }

  ${MediaQuery.S_AND_DOWN} {
    justify-content: center;
    display: flex;
    margin-bottom: 15px;
  }
`;

export const ActionWrapper = styled.form`
  display: flex;
  flex-direction: row;
  width: inherit;
  align-items: center;

  ${MediaQuery.S_AND_DOWN} {
    ${({ is404 }) =>
      !is404 &&
      `
      margin-top: 5px;
    `}
  }

  input {
    height: 22px;
  }

  button {
    margin-left: 15px;
    background-image: ${Gradient.FADE_BLUE};
    color: ${Color.WHITE};
    border: 2px solid transparent;
    min-width: ${({ is404 }) => is404 && '100px'};

    &:hover {
      background-image: none;
      border: 2px solid ${Color.BLUE_RIBBON};
      color: ${Color.BLUE_RIBBON};
      background-color: ${Color.WHITE};
    }

    &:focus {
      background-image: none;
      border: 2px solid ${Color.CLOUD_BURST};
      color: ${Color.BLUE_RIBBON};
      background-color: ${Color.WHISPER};
    }
  }

  div {
    flex: 1 1 auto;
  }
`;
